import React, { useEffect, useState } from 'react';
import GridContainer from '../../../../../@jumbo/components/GridContainer';
import AppTextInput from '../../../../../@jumbo/components/Common/formElements/AppTextInput';
import {
  Button,
  Box,
  Grid,
  /* makeStyles, */ Modal,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from '@material-ui/core';
import Select, { components } from 'react-select';
import { validarRutSeparado, validarMail } from '../../../../../@jumbo/utils/validaciones';
import { rutFormater } from '../../../../../@jumbo/utils/formaters';
import { CircularProgress } from '@material-ui/core';
import { toast } from '@jumbo/components/custom/Toast';
import { Delete } from '@material-ui/icons';
import DDLInput from '@jumbo/components/custom/Inputs/DDLInput';
import { crearUsuario, /* getDataRed, */ getNetworkMembers, getOrganizationById } from 'services/api';

/* const addStyle = makeStyles(theme => ({
  dialogRoot: {
    position: 'relative',
  },
  dialogTitleRoot: {
    '& .MuiTypography-h6': {
      fontSize: 16,
      color: theme.palette.common.dark,
    },
  },
})); */

const msgStyles = {
  background: 'skyblue',
  color: 'black',
};

const NoOptionsMessage = props => {
  return (
    <components.NoOptionsMessage {...props}>
      <span>No hay mas opciones</span>
    </components.NoOptionsMessage>
  );
};

const CreateUserDialog = props => {
  const { openDialog = false, close, submit, /* rolesList = [], */ aplicaciones, organization } = props;

  const user = JSON.parse(sessionStorage.getItem('user'));
  /* const classes = addStyle(); */

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: 450,
    minWidth: 350,
    bgcolor: 'background.paper',
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
  };

  const [run, setRun] = useState('');
  const [runError, setRunError] = useState('');
  const [dv, setDv] = useState('');
  const [dvError, setDvError] = useState('');
  const [names, setNames] = useState('');
  const [namesError, setNamesError] = useState('');
  const [lastName, setLastName] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [motherLastName, setMotherLastName] = useState('');
  const [motherLastNameError, setMotherLastNameError] = useState('');
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');

  /*   const [rolesError, setRolesError] = useState('');
  const [reloadRoles, setReloadRoles] = useState(true); */
  const [loading, setLoading] = useState(false);
  const [step1Valid, setStep1Valid] = useState(false);
  const [step2Valid, setStep2Valid] = useState(false);

  /* datos aplicaciones roles */

  const [roles, setRoles] = useState([]);
  /*  const [rolesDisabled, setRolesDisabled] = useState(true); */
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [rolesSelected, setRolesSelected] = useState([]);

  const [modalStep, setModalStep] = useState(0);

  const [dropDownOptionsRoles, setDropDownOptionsRoles] = useState([]);

  const [isNewUserNetwork, setIsNewUserNetwork] = useState('SI');
  const [nombrePrestadorEnRed, setNombrePrestadorEnRed] = useState('');
  const [nombrePrestadorEnRedError, setNombrePrestadorEnRedError] = useState('');
  const [listaPrestadoresDeRed, setListaPrestadoresDeRed] = useState([]);
  const [dropAplicacionMasRoles, setDropDownAplicacionMasRoles] = useState('')

  const [prestadoresRedCompleto, setPrestadoresRedCompleto] = useState([])

  const onCloseDialog = event => {
    if (loading) {
      event.preventDefault();
      return;
    }

    setLoading(false);
    setRun('');
    setDv('');
    setNames('');
    setLastName('');
    setMotherLastName('');
    setEmail('');
    setRoles([]);

    setRunError('');
    setDvError('');
    setNamesError('');
    setLastNameError('');
    setEmailError('');
    setIsNewUserNetwork('SI');
    setNombrePrestadorEnRed('');
    setNombrePrestadorEnRedError('');
    setModalStep(0)
    /*  setRolesError([]); */

    close();
  };

  useEffect(() => {
    if (user.is_network) {
      if (user.organization.network_id) {
        getNetworkMembers(user.organization.network_id)
          .then(resNet => {
            let prestadores = resNet.data.members.map((item, index) => {
              return item.name
            })

            setListaPrestadoresDeRed(prestadores)
            setPrestadoresRedCompleto(resNet.data.members)
          })
          .catch(error => {

          })
          .finally(fin => {

          })
      }

      // let names = user.user_organizations.map((item) => { return item.name })
      // setListaPrestadoresDeRed(names)
    }

    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    validateStep2();
    // eslint-disable-next-line
  }, [roles]);

  useEffect(() => {
    if (aplicaciones.length) {
      let aux_app_con_rol = []
      aplicaciones.map(app => {
        app.roles.map(rol => {
          let obj_completo = {
            label: app.name + ' - ' + rol.name,
            value: app.id + "" + rol.id,
            valorAgregar: {
              app: {
                value: app.id,
                label: app.name
              },
              rol: {
                value: rol.id,
                label: rol.name
              }
            }
          }
          aux_app_con_rol.push(obj_completo)
        })
      })

      setDropDownAplicacionMasRoles(aux_app_con_rol)
    }
    // eslint-disable-next-line
  }, [aplicaciones]);


  useEffect(() => {
    validateStep1()
    // eslint-disable-next-line
  }, [nombrePrestadorEnRed])

  useEffect(() => {
    validateStep1()
    // eslint-disable-next-line
  }, [isNewUserNetwork])

  /*   const getDatosredApi = async () => {
      getDataRed(14)
    } */

  const postRoles = () => {
    return roles.map(item => {
      return item.rol.value;
    });
  };

  const handlerRun = e => {
    var val = e.target.value.split('.').join('');
    if (/^\d{0,8}$/g.test(val)) {
      setRun(rutFormater(val));
      setRunError('');
    }
  };

  const handlerDv = e => {
    var val = e.target.value;
    if (/^[\dkK]{0,1}$/g.test(val)) {
      setDv(val);
      setDvError('');
    }
  };

  const validate = () => {
    var res = true;
    if (!run) {
      setRunError('Debe ingresar un run');
      res = false;
    }
    if (!dv) {
      setDvError('falta dv');
      res = false;
    }
    if (!validarRutSeparado(run, dv)) {
      setDvError('no valido');
      res = false;
    }
    if (!names) {
      setNamesError('Debe ingresar al menos un nombre');
      res = false;
    }
    if (!lastName) {
      setLastNameError('Debe ingresar un primer Apellido');
      res = false;
    }
    if (!email) {
      setEmailError('Debe ingresar un correo electronico');
      res = false;
    }
    if (!validarMail(email)) {
      setEmailError('Correo no valido');
      res = false;
    }
    if (roles.length === 0) {
      toast.error('Debe seleccionar al menos un rol');
      /*  setRolesError('Debe agregar al menos un rol'); */
      res = false;
    }

    return res;
  };

  const validateStep1 = () => {
    var res = true;
    if (!run) {
      setRunError('Debe ingresar un run');
      res = false;
    }
    if (!dv) {
      setDvError('falta dv');
      res = false;
    }
    if (!validarRutSeparado(run, dv)) {
      setDvError('no valido');
      res = false;
    }
    if (!names) {
      setNamesError('Debe ingresar al menos un nombre');
      res = false;
    }
    if (!lastName) {
      setLastNameError('Debe ingresar un primer Apellido');
      res = false;
    }
    if (!email) {
      setEmailError('Debe ingresar un correo electronico');
      res = false;
    }
    if (!validarMail(email)) {
      setEmailError('Correo no valido');
      res = false;
    }
    if (user.is_network) {
      if (isNewUserNetwork === 'SI') {
        if (!nombrePrestadorEnRed) {
          setNombrePrestadorEnRedError('Debe ingresar un prestador');
          /* revisar bien la validacion de formulario */
          res = false;
        }
      } else {

      }
    }
    setStep1Valid(res);

    return res;
  };

  const validateStep2 = () => {
    var res = true;
    if (roles.length === 0) {
      //toast.error('Debe seleccionar al menos un rol');
      /*  setRolesError('Debe agregar al menos un rol'); */
      res = false;
    }
    setStep2Valid(res);
    return res;
  };

  const createNormalUser = () => {
    var auxUser = {};
    auxUser.organization_id = user.organization_id;
    auxUser.run = Number(run.split('.').join(''));
    auxUser.dv = String(dv);
    auxUser.type_user = String('CU');
    auxUser.is_network = false;
    auxUser.names = names;
    auxUser.last_name = lastName;
    auxUser.email = email;
    auxUser.roles_user = postRoles();
    if (motherLastName) {
      auxUser.mother_last_name = motherLastName;
    }

    auxUser.organization = {
      name: organization.name,
      code: organization.code,
      type_id: organization.type_id,
    };

    return auxUser
  }

  const getPrestadorId = (nombrePrestador) => {
   // let aux = user.user_organizations.find(e => e.name === nombrePrestador)
   let aux = prestadoresRedCompleto.find(e => e.name === nombrePrestador)
    return aux.id
  }

  const createNetworkUser = () => {
    var auxUser = {};
    getOrganizationById(getPrestadorId(nombrePrestadorEnRed))
      .then(res => {
        auxUser.organization = {
          name: res.data.name,
          code: res.data.code,
          type_id: res.data.type_id,
        };
      })
      .catch(e => console.error(e))
      .finally(f => {

        getNetworkMembers(user.organization.network_id)
          .then(resMembers => {
            auxUser.user_organizations = resMembers.data.members
          })
          .catch(e => console.error(e))
          .finally(fMembers => {
            auxUser.organization_id = getPrestadorId(nombrePrestadorEnRed);
            auxUser.run = Number(run.split('.').join(''));
            auxUser.dv = String(dv);
            auxUser.type_user = String('CU');
            auxUser.is_network = true;
            auxUser.names = names;
            auxUser.last_name = lastName;
            auxUser.email = email;
            auxUser.roles_user = postRoles();
            if (motherLastName) {
              auxUser.mother_last_name = motherLastName;
            }

            crearUsuario(auxUser)
              .then(res => {
                toast.success('Usuario creado correctamente.');
                onCloseDialog();
                submit();
              })
              .catch(err => {
                console.log(err);
                toast.error(err.response.data.detail);
              })
              .finally(e => {
                setLoading(false);
              });
          })

      })


  }

  const onSubmitClick = () => {
    setLoading(true);

    if (!validate()) {
      setLoading(false);
      return;
    }

    if (isNewUserNetwork === "NO" || !user.is_network) {
      crearUsuario(createNormalUser())
        .then(res => {
          toast.success('Usuario creado correctamente.');
          onCloseDialog();
          submit();
        })
        .catch(err => {
          console.log(err);
          toast.error(err.response.data.detail);
        })
        .finally(e => {
          setLoading(false);
        });
    } else {
      createNetworkUser()
    }


  };

  const handleChangeNetwork = event => {
    setNombrePrestadorEnRed('');
    setNombrePrestadorEnRedError('')
    setIsNewUserNetwork(event.target.value);

  };

  const handleChangeRol = evt => {
    let aux = [];
    // eslint-disable-next-line
    evt.map((item, index) => {
      aux.push(item);
    });
    setRolesSelected(aux);
  };

  const handleChangeAplicacion = evt => {
    if (evt === null) {
      setRolesSelected([]);
      setSelectedApplication(evt);
    } else {
      let aux = [];
      aplicaciones.map((item, index) => {
        if (item.id === evt.value) {
          aux = item.roles;
        }
        return null;
      });
      let aux2 = [];
      /* aux2.push({ value: 2, label: 'Administrador' }); */
      aux.map((item, index) => {
        let obg = {
          value: item.id,
          label: item.name,
        };
        aux2.push(obg);
        return null;
      });
      setDropDownOptionsRoles(aux2);
      setSelectedApplication(evt);
    }
  };

  const handleNext = () => {
    setModalStep(1);
  };

  const handleBack = () => {
    setModalStep(0);
  };


  const dropDownOptionsAplicaciones = [];
  /* const dropDownOptionsAplicaciones = [{ value: '1', label: 'Seguimiento de reclamos' }]; */
  aplicaciones.map((item, index) => {
    let auxItem = {
      value: item.id,
      label: item.name,
    };
    dropDownOptionsAplicaciones.push(auxItem);
    return null;
  });

  const removeRol = (appLabel, rolLabel) => {
    setRoles(roles.filter(item => !(item.app.label === appLabel && item.rol.label === rolLabel)));
  };

  const getAplicacionesConRoles = () => {
    return roles.map((item, index) => {
      return (
        <div key={index}>
          {index === 0 ? <hr /> : null}
          <Grid container spacing={0} key={index} style={{ marginTop: 5 }}>
            <Grid item xs={4} style={{ textAlign: 'center' }}>
              {item.app.label}
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'center' }}>
              {item.rol.label}
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'end', color: 'red' }}>
              <Delete
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  removeRol(item.app.label, item.rol.label);
                }}
              />
            </Grid>
          </Grid>
          <hr />
        </div>
      );
    });
  };

  const isRolesDisabled = () => {
    if (selectedApplication === null) {
      return true;
    } else {
      return false;
    }
  };

  const isInArray = elem => {
    let aux = false;

    roles.map((item, index) => {
      if (item.app.label === elem.app.label && item.rol.label === elem.rol.label) {
        aux = true;
      }
      return null;
    });

    return aux;
  };

  const agregarAppConRolSelect = () => {

  }



  const agregarRolesPorApp = () => {
    if (selectedApplication !== null) {
      if (rolesSelected.length > 0) {
        /* aca el setRoles */
        let aux = [];

        roles.map((item, index) => {
          aux.push(item);
          return null;
        });

        rolesSelected.map((item, index) => {
          let objApp = {
            app: selectedApplication,
            rol: item,
          };

          if (!isInArray(objApp)) {
            aux.push(objApp);
          } else {
            toast.error('Ese rol ya está en la lista');
          }

          return null;
        });

        console.log('aux', aux)
        console.log('aplicaciones', aplicaciones)

        setRoles(aux);
        setSelectedApplication(null); //devuelve el select de aplicacion a "seleccione aplicacion"
        setRolesSelected([]); //devuelve el select a "seleccione rol"
      } else {
        toast.error('Debe seleccionar al menos un rol');
      }
    } else {
      toast.error('Debe seleccionar una aplicacion');
    }
  };

  const getCreateUserContent = () => {
    if (modalStep === 0) {
      return (
        <div>
          <h2 style={{ marginBottom: 5 }}>Datos de usuario paso 1 de 2</h2>
          <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
            <GridContainer>
              <Grid item xs={8} sm={8}>
                <AppTextInput
                  fullWidth
                  variant="outlined"
                  label="Rut"
                  value={run}
                  onChange={event => handlerRun(event)}
                  helperText={runError}
                  onBlur={validateStep1}
                />
              </Grid>
              <Grid item xs={4} sm={4}>
                <AppTextInput
                  fullWidth
                  variant="outlined"
                  label="DV"
                  value={dv}
                  onChange={event => handlerDv(event)}
                  helperText={dvError}
                  onBlur={validateStep1}
                />
              </Grid>
            </GridContainer>
          </Box>
          <Box mb={{ xs: 6, md: 5 }}>
            <AppTextInput
              fullWidth
              variant="outlined"
              label="Nombres"
              value={names}
              onChange={e => {
                setNames(e.target.value);
                setNamesError('');
              }}
              helperText={namesError}
              onBlur={validateStep1}
            />
          </Box>
          <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
            <GridContainer>
              <Grid item xs={12} sm={6}>
                <AppTextInput
                  fullWidth
                  variant="outlined"
                  label="Primer Apellido"
                  value={lastName}
                  onChange={e => {
                    setLastName(e.target.value);
                    setLastNameError('');
                  }}
                  helperText={lastNameError}
                  onBlur={validateStep1}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <AppTextInput
                  fullWidth
                  variant="outlined"
                  label="Segundo Apellido"
                  value={motherLastName}
                  onChange={e => {
                    setMotherLastName(e.target.value);
                    setMotherLastNameError('');
                  }}
                  helperText={motherLastNameError}
                />
              </Grid>
            </GridContainer>
          </Box>

          <Box mb={{ xs: 6, md: 5 }}>
            <AppTextInput
              fullWidth
              variant="outlined"
              label="Correo Electronico"
              value={email}
              onChange={e => {
                setEmail(e.target.value);
                setEmailError('');
              }}
              helperText={emailError}
              onBlur={validateStep1}
            />
          </Box>

          {/* aca va si pertenece a red */}
          {user.is_network ? (
            <Box display="flex" flexDirection={{ xs: 'column', md: 'row' }} alignItems="center" mb={{ xs: 6, md: 5 }}>
              <GridContainer>
                <Grid item xs={6} sm={6}>
                  <FormControl>
                    <FormLabel id="demo-row-radio-buttons-group-label">Ver reclamos de toda la red</FormLabel>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={isNewUserNetwork}
                      onChange={handleChangeNetwork}>
                      <FormControlLabel value="SI" control={<Radio />} label="Si" />
                      <FormControlLabel value="NO" control={<Radio />} label="No" />
                    </RadioGroup>
                  </FormControl>
                </Grid>
                <Grid item xs={6} sm={6}>
                  <DDLInput

                    //style="font-size:8pt"
                    label="Nombre Prestador"
                    value={nombrePrestadorEnRed}
                    lista={listaPrestadoresDeRed}
                    onChange={res => {
                      setNombrePrestadorEnRed(res);
                      setNombrePrestadorEnRedError('');

                    }}
                    onSelect={listIndex => {
                      setNombrePrestadorEnRed(listaPrestadoresDeRed[listIndex]);
                      setNombrePrestadorEnRedError('');

                    }}
                    error={nombrePrestadorEnRedError}
                  />
                </Grid>
              </GridContainer>
            </Box>
          ) : null}
        </div>
      );
    } else {
      return (
        <div>
          <h2 style={{ marginBottom: 5 }}>Roles de usuario paso 2 de 2</h2>

          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={0}>
{/*               <Grid item xs={5}>
                <Select
                  placeholder="Seleccione Aplicación"
                  options={dropDownOptionsAplicaciones}
                  onChange={handleChangeAplicacion}
                  value={selectedApplication}
                  isClearable={true}
                />
              </Grid>
              <Grid item xs={5}>
                <Select
                  placeholder="Seleccione Rol"
                  options={dropDownOptionsRoles}
                  onChange={handleChangeRol}
                  isDisabled={isRolesDisabled()}
                  isMulti={true}
                  value={rolesSelected}
                  components={{ NoOptionsMessage }}
                  styles={{ noOptionsMessage: base => ({ ...base, ...msgStyles }) }}
                />
              </Grid> */}
              <Grid item xs={12}>
                <Select
                  placeholder="Seleccione Aplicación y rol para el usuario"
                  options={dropAplicacionMasRoles}
                  onChange={(e) => {
                    setRoles(prev => {
                      const exists = prev.some(
                        r =>
                          r.app.value === e.valorAgregar.app.value &&
                          r.rol.value === e.valorAgregar.rol.value
                      );

                      if (exists) return prev;

                      return [...prev, e.valorAgregar];
                    });
                  }}
                  value={rolesSelected}
                  components={{ NoOptionsMessage }}
                  styles={{ noOptionsMessage: base => ({ ...base, ...msgStyles }) }}
                />
              </Grid>
{/*               <Grid item xs={2} style={{ textAlign: 'center' }}>
                <Button variant="outlined" color="primary" onClick={agregarRolesPorApp}>
                  Agregar
                </Button>
              </Grid> */}
            </Grid>
          </Box>
          <Box sx={{ flexGrow: 1 }}>{getAplicacionesConRoles()}</Box>
        </div>
      );
    }
  };

  return (
    <Modal open={openDialog} onClose={onCloseDialog}>
      <Box sx={style} flexDirection="column" justifyContent="space-between">
        {getCreateUserContent()}
        <Box display="flex" justifyContent="flex-end" style={{ position: 'absolute', bottom: 0, right: 16 }} mb={4}>
          {modalStep === 0 ? (
            <Button onClick={onCloseDialog} disabled={loading}>
              Cancelar
            </Button>
          ) : (
            <div>
              <Button onClick={onCloseDialog} disabled={loading}>
                Cancelar
              </Button>
              <Button onClick={handleBack} disabled={loading}>
                Atrás
              </Button>
            </div>
          )}
          <Box ml={2}>
            {modalStep === 0 ? (
              <Button variant="outlined" color="primary" onClick={handleNext} disabled={!step1Valid}>
                {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Siguiente'}
              </Button>
            ) : (
              <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={!step2Valid}>
                {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Crear'}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default CreateUserDialog;
